import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

import '~styles/modules/topper.scss';

const TopperContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  .titleText {
    max-width: 350px;
  }
  .titleImg {
    max-width: 350px;
  }
`;
const Topper = ({ children }) => (
  <TopperContainer className="topper content">

    <div className="titleText">{children}</div>
    <StaticImage className="titleImg" src="../../assets/images/ortiz-bc-silo-sm.png" alt="Photo by Barry Chin" />
  </TopperContainer>
);

Topper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Topper;
